import { useEffect, useMemo } from "react";
import { useNavigate } from "react-router-dom";
import { useDeals, useStakeDebit, useUnclaimedTransactions } from "../../CustomHooks/Queries";
import { useAppUtilityContext } from "../../Contexts/AppUtilityContext";
import {
  BATTLECARD_FLOW_NAV_STATE,
  BATTLECARD_PLAN_SELECTION_NAV_STATE,
  getBattlecardPageSubtitle,
  getUnclaimedCashBackAmount,
} from "../../Utils/helpers";
import BattlecardHeaderLayout from "./battlecard-header-layout";
import "./battle-cards.scss";

const STEPS = [
  { number: 1, title: "Get Stake Visa", description: "100% free." },
  { number: 2, title: "Connect Paycheck", description: "Deposit your rent amount or Pay Rent with Stake" },
  { number: 3, title: null, description: null },
];

export default function PayRent() {
  const navigate = useNavigate();
  const { setAppUtilityProps } = useAppUtilityContext();
  const { data: dealsData } = useDeals();
  const { data: stakeDebitData } = useStakeDebit();
  const { data: unclaimedTransactionsData } = useUnclaimedTransactions();

  const pageSubtitle = useMemo(
    () => getBattlecardPageSubtitle(dealsData, stakeDebitData),
    [dealsData, stakeDebitData]
  );

  const cashBackAmount = useMemo(
    () => getUnclaimedCashBackAmount(unclaimedTransactionsData),
    [unclaimedTransactionsData]
  );

  const steps = useMemo(
    () =>
      STEPS.map((step, index) =>
        index === 2 ? { ...step, title: `Get ${cashBackAmount} instantly` } : step
      ),
    [cashBackAmount]
  );

  useEffect(() => {
    setAppUtilityProps((p) => ({ ...p, hideNavigationBar: true, lockedRoutes: ["/deals", "/cash"] }));
    return () => setAppUtilityProps((p) => ({ ...p, lockedRoutes: [] }));
  }, [setAppUtilityProps]);

  function handleGetStarted() {
    navigate("/battlecard/member-setup", {
      state: { ...BATTLECARD_FLOW_NAV_STATE, returnTo: "/battlecard/pay-rent" },
    });
  }

  return (
    <BattlecardHeaderLayout>
      <div className="battle-cards-page bc-plan-steps-page bc-plan-steps-page--unlimited">
        <div className="bc-scene active">
        <div className="bc-plan-steps-layout">
          <div className="bc-plan-steps-header">
            <h1 className="bc-page-title">Your Move-In Cash is waiting for you.</h1>
            <p className="bc-page-subtitle">{pageSubtitle}</p>
          </div>

          <div className="bc-plan-steps-card-wrap">
            <div className="bc-plan-steps-card">
              <div className="bc-plan-steps-card-header">
                <div className="bc-card-plan-name green">Unlimited</div>
                <div className="bc-card-subtitle">Cash Back for shopping and paying rent</div>
              </div>

              <div className="bc-plan-steps-list">
                {steps.map((step, index) => (
                  <div key={step.number} className="bc-plan-steps-item">
                    <div className="bc-plan-steps-indicator">
                      <div className="bc-plan-steps-circle">{step.number}</div>
                      {index < steps.length - 1 && <div className="bc-plan-steps-line" />}
                    </div>
                    <div className="bc-plan-steps-text">
                      <span className="bc-plan-steps-title">{step.title}</span>
                      {step.description && <span className="bc-plan-steps-desc">{step.description}</span>}
                    </div>
                  </div>
                ))}
              </div>

              <div className="bc-plan-steps-card-footer">
                <button type="button" className="bc-plan-steps-btn" onClick={handleGetStarted}>
                  Get Started
                </button>
                <div className="bc-plan-steps-est">Est time: 2 minutes</div>
              </div>
            </div>
            <span className="bc-most-popular-badge">Most Popular</span>
          </div>

          <button
            type="button"
            className="bc-footer-link"
            onClick={() => navigate("/battlecard", { state: BATTLECARD_PLAN_SELECTION_NAV_STATE })}
          >
            Go back
          </button>
        </div>
        </div>
      </div>
    </BattlecardHeaderLayout>
  );
}
